import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/assets/images/image-animal.webp'
import _imports_1 from '../../public/assets/images/image-plants.webp'


const _withScopeId = n => (_pushScopeId("data-v-e8b60812"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "card-image",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "card-image",
  src: _imports_1,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ion_card, { class: "card" }, {
      default: _withCtx(() => [
        (_ctx.image === 'animals')
          ? (_openBlock(), _createBlock(_component_ion_card_header, {
              key: 0,
              class: "card-header"
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_ion_card_title, {
                  class: _normalizeClass([_ctx.fontSizeTitle, "card-title"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.title), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }))
          : (_ctx.image === 'plants')
            ? (_openBlock(), _createBlock(_component_ion_card_header, {
                key: 1,
                class: "card-header"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_ion_card_title, {
                    class: _normalizeClass([_ctx.fontSizeTitle, "card-title"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.title), 1)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
        _createVNode(_component_ion_card_content, { class: "card-content" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_list, {
              class: "card-list",
              lines: "none"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: entry.id,
                    class: "card-item",
                    button: "",
                    onClick: ($event: any) => (_ctx.$router.push({ name: 'Details', params: { id: `${entry.url}` }})),
                    detail: "false",
                    style: {"color":"var(--ion-color-primary)"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_text, {
                        color: "primary",
                        class: _normalizeClass(_ctx.fontSize)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(entry.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"]),
                      _createVNode(_component_ion_icon, {
                        class: "item-icon",
                        icon: _ctx.caretForwardOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}